import React, { useState, useEffect } from 'react';
import { Button, Modal } from 'react-bootstrap';
import { Link } from "react-router-dom";
import DatePicker, { DateObject } from "react-multi-date-picker";
import TimePicker from "react-multi-date-picker/plugins/time_picker";
import FileUpload from "react-material-file-upload";
import * as XLSX from "xlsx";
import axios from 'axios';
import lead_import_file from '../../../../images/leads_sample_import.xlsx';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Swal from 'sweetalert2';

const LeadImport = ({ show, onClose, refresh, count }) => {
    const branch_id = parseInt(localStorage.getItem("branch_id"), 10);
    const baseURL = process.env.REACT_APP_API_BASE_URL;
    const [leadSources, setLeadSources] = useState([]);
    const [area, setarea] = useState([]);

    useEffect(() => {
        axios.get(`${baseURL}/leadsource`)  // Replace with your actual endpoint
            .then(res => {
                setLeadSources(res.data.data.data);  // Assuming res.data is an array like [{ id: 1, name: "Website" }, ...]
            })
            .catch(err => console.error("Failed to load lead sources", err));
    }, []);

    useEffect(() => {
        axios.get(`${baseURL}/dropdown/area`, { params: { branch_id: branch_id } })  // Replace with your actual endpoint
            .then(res => {
                setarea(res.data.data);  // Assuming res.data is an array like [{ id: 1, name: "Website" }, ...]
            })
            .catch(err => console.error("Failed to load lead sources", err));
    }, []);

    const [productoptions, setProductoption] = useState([]);
    useEffect(() => {
        const fetchdata = async () => {
            try {
                const response = await axios.get(`${baseURL}/manage-products/products/active`);
                const formatted = response.data.data.map(item => ({
                    value: item.sno,
                    label: item.product_name,
                }));
                setProductoption(formatted);
            } catch (error) {
                console.error('Error fetching data', error);
            }
        };

        fetchdata();
    }, []);

    const getLeadSourceId = (name) => {
        // console.log(name);
        // console.log(leadSources);
        const source = leadSources.find(src => src.leadsource_name.trim().toLowerCase() === name.trim().toLowerCase());
        // console.log(source);
        return source ? source.sno : 3;  // Default to 1 or handle error
    };

    const productsId = (name) => {
        // console.log(name);
        // console.log(productoptions);
        const prod = productoptions.find(src => src.label.trim().toLowerCase() === name.trim().toLowerCase());
        // console.log(prod);
        return prod ? prod.value.toString() : "";
    };

    const areaid = (name) => {
        // console.log(name);
        // console.log(area);
        const areaID = area.find(src => src.area_name.trim().toLowerCase() === name.trim().toLowerCase());
        // console.log(areaID);
        // return areaID ? areaID.sno : 1;
        return areaID ? areaID.sno : (area.length > 0 ? area[area.length - 1].sno : null);
    };

    const handleDownload = () => {
        const link = document.createElement('a');
        link.href = lead_import_file;  // Set the file URL
        link.download = 'Sample Lead Import File';  // Optionally, specify the file name here
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    const [data_name, setData] = useState([]);
    const [data_mobile, setMob] = useState([]);
    const [data_email, setem] = useState([]);

    useEffect(() => {
        const params = {
            branch_id: branch_id
        };
        // axios.get(`${baseURL}/managelead`,  { params: params })
        axios.get(`${baseURL}/managelead/all_lead`)
            .then(response => {
                setData(response.data.data.map(mode => mode.lead_name.toLowerCase()));
                setMob(response.data.data.map(mode => mode.mobile_no));
                setem(response.data.data.map(em => em.email_id?.toLowerCase()).filter(email => email));
            })
            .catch(error => {
                console.log('There was an error fetching the data!', error);
            });
    }, [])

    const user_id = parseInt(localStorage.getItem("user_id"), 10);

    const [errors, setErrors] = useState({});
    const [loading, setLoading] = useState(false);
    const handleFileUpload = async () => {
        if (!files || files.length === 0) {
            const newErrors = {};
            newErrors.name = "This Field is Required.";
            setErrors(newErrors);
            return
        }

        setLoading(true); // Start loading

        const file = files[0];
        const reader = new FileReader();

        reader.onload = async (e) => {
            const data = new Uint8Array(e.target.result);
            const workbook = XLSX.read(data, { type: "array" });
            const sheetName = workbook.SheetNames[0];
            const worksheet = workbook.Sheets[sheetName];
            let jsonData = XLSX.utils.sheet_to_json(worksheet, {
                defval: "", // replaces undefined with empty string
                blankrows: false, // skips blank rows
                raw: false // converts dates correctly
            });

            jsonData = jsonData
                .map(row => {
                    // Remove keys that don't match expected headers
                    const allowedKeys = ["Lead Name*", "Area*", "Lead Source*", "Mobile No*", "Products", "Email ID", "Address"];
                    const cleanedRow = {};

                    for (let key in row) {
                        if (allowedKeys.includes(key) && row[key] && row[key].toString().trim() !== "") {
                            cleanedRow[key] = row[key];
                        }
                    }

                    return cleanedRow;
                })
                .filter(row => Object.keys(row).length > 0);

            // console.log(jsonData);
            try {
                let totalLeads = jsonData.length;
                let createdLeads = 0;
                let notCreatedLeads = 0;

                for (let lead of jsonData) {
                    const leadName = lead["Lead Name*"]?.trim();
                    const areas = lead["Area*"]?.trim();
                    const mobileNo = lead["Mobile No*"]?.toString().trim();
                    const prod = lead["Products"] ? productsId(lead["Products"]) : "";

                    const email = lead["Email ID"]?.trim();
                    const address = lead["Address"]?.trim();

                    let valid = true;

                    // Validation checks
                    if (!leadName || !mobileNo || !areas) valid = false;
                    if (data_mobile.map(String).includes(String(mobileNo))) valid = false;
                    if (String(mobileNo).trim().length !== 10) valid = false;
                    if (/\d/.test(leadName)) valid = false;
                    if (!/^\d+$/.test(mobileNo)) valid = false;
                    if (!/^[6-9]\d{9}$/.test(mobileNo)) {
                        valid = false;
                    }

                    if (email && (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email))) {
                        valid = false;
                    }

                    if (email && data_email.includes(email.trim().toLocaleLowerCase())) {
                        valid = false;
                    }

                    if (valid) {
                        try {
                            const postData = {
                                lead_name: leadName || "",
                                mobile_no: mobileNo || "",
                                email_id: email ? email : "",
                                latitude: "",
                                longitude: "",
                                address: address ? address :"",
                                description: "",
                                lead_type: 4,
                                lead_source: getLeadSourceId(lead["Lead Source*"]) || 1,
                                product: prod,
                                area: areaid(areas) || 1,
                                created_by: user_id,
                                branch_id: branch_id,
                            };

                            await axios.post(`${baseURL}/managelead`, postData);
                            createdLeads++;
                        } catch (err) {
                            notCreatedLeads++;
                            console.log("Error creating lead:", err);
                        }
                    } else {
                        notCreatedLeads++;
                    }
                }

                // ✅ Show Swal after all leads processed
                Swal.fire({
                    icon: 'success',
                    title: 'Lead Import Summary',
                    html: `
                        <p><b>Total Leads:</b> ${totalLeads}</p>
                        <p style="color:green;"><b>Created Leads:</b> ${createdLeads}</p>
                        <p style="color:red;"><b>Not Created Leads:</b> ${notCreatedLeads}</p>
                    `,
                    confirmButtonText: 'OK',
                });

            } catch (error) {
                console.log('Error uploading lead:', error);

                // ❌ Swal on global error
                Swal.fire({
                    icon: 'error',
                    title: 'Lead Import Failed!',
                    html: `
                        <p><b>Total Leads:</b> ${jsonData?.length || 0}</p>
                        <p style="color:red;"><b>Not Created Leads:</b> All</p>
                    `,
                    confirmButtonText: 'OK',
                });

            } finally {
                refresh();
                count();
                onClose();
            }


            // try {

            //     let totalLeads = jsonData.length;
            //     let createdLeads = 0;
            //     let notCreatedLeads = 0;

            //     for (let lead of jsonData) {

            //         const leadName = lead["Lead Name*"]?.trim();
            //         const areas = lead["Area*"]?.trim();
            //         // const sales_person = lead["Sales Person"]?.trim();
            //         const mobileNo = lead["Mobile No*"]?.toString().trim();
            //         const prod = lead["Products"] ? productsId(lead["Products"]) : "";
            //         let valid = true;

            //         // Skip if either name or mobile is missing
            //         if (!leadName || !mobileNo || !areas) {
            //             valid = false;
            //         }

            //         // Check for duplicate name (case-insensitive)
            //         // if (data_name.includes(leadName.toLowerCase())) {
            //         //     valid = false;
            //         // }
            //         console.log(mobileNo, "exts: ", data_mobile);
            //         if (data_mobile.map(String).includes(String(mobileNo))) {
            //             valid = false;
            //         }

            //         if ( String(mobileNo).trim().length !== 10) {
            //             valid = false;
            //         }

            //         // Check if name contains any digits
            //         if (/\d/.test(leadName)) {
            //             valid = false;
            //         }

            //         // Check if mobile number contains only digits
            //         if (!/^\d+$/.test(mobileNo)) {
            //             valid = false;
            //         }


            //         if (valid) {
            //             const postData = {
            //                 lead_name: leadName || "",
            //                 mobile_no: mobileNo || "",
            //                 email_id: lead['Email ID'] || "",
            //                 latitude: "",
            //                 longitude: "",
            //                 address: lead['Address'] || "",
            //                 description: "",
            //                 lead_type: 4,
            //                 lead_source: getLeadSourceId(lead["Lead Source*"]) || 1,
            //                 product: prod,
            //                 area: areaid(areas) || 1,
            //                 // sales_person: sales_person || "",
            //                 created_by: user_id,
            //                 branch_id: branch_id,
            //             };

            //             await axios.post(`${baseURL}/managelead`, postData);

            //             createdLeads++;
            //         }

            //     }
            //     toast.success("Lead Imported successfully!");
            // } catch (error) {
            //     console.error('Error uploading lead:', error);
            //     toast.error(" Lead Import Failed!");
            // } finally {
            //     refresh();
            //     count();
            //     onClose();
            // }
        };
        reader.readAsArrayBuffer(file);

    };

    const [files, setFiles] = useState(null);


    return (
        <Modal show={show} size="md">
            <div className="modal-content border border-red rounded-xxl">
                <div className="modal-header" style={{ backgroundColor: '#3ab384' }}>
                    <h3 className="modal-title text-white">Lead Import</h3>
                    <Button variant="" type="button" className="close px-6 py-2" data-dismiss="modal" onClick={onClose}>
                        <span className="text-white">×</span>
                    </Button>
                </div>
                <div className="modal-body">
                    <div className='row'>
                        <div className="col-lg-12 d-flex justify-content-end mb-2">
                            <label className='text-black fs-6 font-w500'>Sample Download For Lead Import</label>
                            <div onClick={handleDownload} className="ms-2 text-danger" style={{ cursor: 'pointer' }}>
                                <i className="fa-regular fa-circle-down fs-3"></i>
                            </div>
                        </div>
                        <div className="col-lg-12 mb-2">
                            <FileUpload maxFiles='1' value={files} onChange={setFiles} accept=".xlsx,.csv" />
                        </div>
                        {errors.name && <div className="text-danger fs-8 mt-1 text-center">{errors.name}</div>}
                    </div>
                    <div className="d-flex align-items-center justify-content-center gap-3 mt-4 mb-4">
                        <Link type="reset" className="btn btn-sm btn-secondary" onClick={onClose}>Cancel</Link>
                        {/* <Link type="submit" className="btn btn-sm btn-primary" onClick={handleFileUpload}>{loading ? 'Importing...' : 'Import Lead'}</Link> */}
                        <Link
                            type="submit"
                            className={`btn btn-sm btn-primary ${loading ? 'disabled' : ''}`}
                            onClick={!loading ? handleFileUpload : null}
                            style={{ pointerEvents: loading ? 'none' : 'auto', opacity: loading ? 0.6 : 1 }}
                        >
                            {loading ? 'Importing...' : 'Import Lead'}
                        </Link>
                    </div>
                </div>
            </div>
        </Modal>
    );
};

export default LeadImport;
